const CHUNK_RECOVERY_SKIP_SPLASH_KEY = 'mestti:chunk-recovery-skip-splash';

/** Set before a chunk-error reload so the next boot skips the branded splash. */
export function markChunkRecoveryReload(): void {
  try {
    sessionStorage.setItem(CHUNK_RECOVERY_SKIP_SPLASH_KEY, '1');
  } catch {
    // sessionStorage unavailable (private mode, etc.)
  }
}

/** Returns true once per recovery reload; clears the flag. */
export function consumeChunkRecoverySkipSplash(): boolean {
  try {
    if (sessionStorage.getItem(CHUNK_RECOVERY_SKIP_SPLASH_KEY) !== '1') {
      return false;
    }
    sessionStorage.removeItem(CHUNK_RECOVERY_SKIP_SPLASH_KEY);
    return true;
  } catch {
    return false;
  }
}

/** @internal */
export function resetChunkRecoveryForTests(): void {
  try {
    sessionStorage.removeItem(CHUNK_RECOVERY_SKIP_SPLASH_KEY);
  } catch {
    // ignore
  }
}
